import React, { useLayoutEffect } from 'react';
import { getConfigFrontEnd } from '../../../src/components/use-config-fe';
import '../css/custom-form.css';

export interface ICustomFormProps {
    children?: any;
}

const CustomForm = (props: ICustomFormProps) => {
    const configCustomForm = getConfigFrontEnd({ name: 'CustomForm' });
    useLayoutEffect(() => {
        const script = document.createElement('script');
        script.src = configCustomForm;
        script.async = true;

        document.body.appendChild(script);
        return () => {};
    }, []);

    return <div className="_form_1" />;
};

export default CustomForm;
